/* =========================================================
   THEME.JS — comportamiento global del tema
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Menú móvil ---------- */
  var burger = document.querySelector('[data-mobile-nav-open]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var closeBtn = document.querySelector('[data-mobile-nav-close]');

  function toggleMobileNav(open) {
    if (!mobileNav) return;
    if (open) {
      mobileNav.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    } else {
      mobileNav.removeAttribute('open');
      document.body.style.overflow = '';
    }
  }
  if (burger) burger.addEventListener('click', function () { toggleMobileNav(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { toggleMobileNav(false); });

  /* ---------- Header: sombra/fondo al hacer scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Grid de producto: animación escalonada ---------- */
  document.querySelectorAll('.product-grid').forEach(function (grid) {
    var cards = grid.querySelectorAll('.product-card');
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 60);
            cio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      cards.forEach(function (c) { cio.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
    }
  });

  /* ---------- Newsletter: feedback de envío ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.textContent = 'Enviando…';
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  if (searchInput && searchResults) {
    var searchTimeout;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.hidden = true; return; }
      searchTimeout = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { searchResults.innerHTML = '<p class="empty-state">Sin resultados</p>'; searchResults.hidden = false; return; }
            searchResults.innerHTML = products.map(function (p) {
              return '<a class="predictive-search-item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" width="52" height="52" alt="" loading="lazy">' : '') +
                '<span>' + p.title + '</span></a>';
            }).join('');
            searchResults.hidden = false;
          });
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) searchResults.hidden = true;
    });
  }
});
